import { render, staticRenderFns } from "./AddFromUser.vue?vue&type=template&id=2b3aba19&scoped=true"
import script from "./AddFromUser.vue?vue&type=script&lang=js"
export * from "./AddFromUser.vue?vue&type=script&lang=js"
import style0 from "./AddFromUser.vue?vue&type=style&index=0&id=2b3aba19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3aba19",
  null
  
)

export default component.exports